import { useState } from 'react';
import arrowIcon from '../../images/arrowIcon.svg';
import './GridViewCollapse.css'

export interface IGridViewCollapaseParams {
    id: string,
    title: string
    children: React.ReactNode
}
const GridViewCollapase: React.FC<IGridViewCollapaseParams> = ({ id, children, title }) => {
    const [isOpen, setIsOpen] = useState(id === "1");

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <div className='mb-4 gridview' id={id}>
                    <div className='row' onClick={handleToggle} style={{cursor: 'pointer'}}>
                        <div className='col-12 d-flex p-3'>
                            <div className='col gridview-header'>
                                <b>{id}. {title}</b>
                            </div>
                        <div className='col-2 d-flex justify-content-end align-items-center' style={{ height: '22px' }}>
                            <button 
                                className="btn btn-sm"
                                onClick={handleToggle}
                                aria-label={isOpen ? "Collapse" : "Expand"}
                            >
                                <img 
                                    src={arrowIcon} 
                                    alt={isOpen ? "Collapse" : "Expand"} 
                                    style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease', width: '16px', height: '16px' }}
                                />
                            </button>
                        </div>
                    </div>
                    </div>
                    {isOpen && (
                        <div>
                            {children}
                        </div>
                    )}
                </div>

        </>
    )
}
export default GridViewCollapase; 